
<div class="countable-form-container card flex-box-row">
    <div class="card-body">
        <ng-container *ngIf="!showPwdSuccessful">
            <h4 class="title mb-4 text-center">Change Password</h4>
            <form class="d-flex flex-column gap-20" [formGroup]="resetForm" autocomplete="off">
                <mat-form-field class="fixed-label w-100 icon-form-after" floatLabel="always">
                    <mat-label>Current Password</mat-label>
                    <input matInput placeholder="Current Password" [type]="showCurrPassword ? 'text' : 'password'"
                        formControlName="currentPassword" (input)="checkCurrentPassword($event)" required>
                        <span matSuffix>
                            <button mat-button class="button-text" (click)="showCurrPassword = !showCurrPassword">
                                <i class="fa-regular"[ngClass]="(!showCurrPassword ? 'fa-eye-slash' : 'fa-eye')"></i>
                            </button>
                        </span>
                </mat-form-field>

                <mat-form-field class="fixed-label w-100 icon-form-after" floatLabel="always">
                    <mat-label>Enter Password</mat-label>
                    <input [type]="showPassword ? 'text' : 'password'" (input)="checkNewPassword($event)"
                        formControlName="newPassword" name="password" matInput placeholder="Enter Password" required
                        maxlength="25" autocomplete="new-password">
                        <span matSuffix>
                            <button mat-button class="button-text" (click)="showPassword = !showPassword">
                                <i class="fa-regular"[ngClass]="(!showPassword ? 'fa-eye-slash' : 'fa-eye')"></i>
                            </button>
                        </span>
                </mat-form-field>

                <mat-form-field class="fixed-label w-100 icon-form-after" floatLabel="always">
                    <mat-label>Re-enter Password</mat-label>
                    <input [type]="showConfPassword ? 'text' : 'password'"
                        formControlName="confirmPassword" name="confirmPassword" matInput
                        placeholder="Re-enter Password" maxlength="25" required
                        (input)="enableSubmitButton()"
                        autocomplete="new-password" [errorStateMatcher]="matcher">
                        <span matSuffix>
                            <button mat-button class="button-text" (click)="showConfPassword = !showConfPassword">
                                <i class="fa-regular"[ngClass]="(!showConfPassword ? 'fa-eye-slash' : 'fa-eye')"></i>
                            </button>
                        </span>
                    <mat-error *ngIf="resetForm.hasError('notSame') && (resetForm.get('confirmPassword').dirty || resetForm.get('confirmPassword').touched)">
                        Password doesn't match
                    </mat-error>
                </mat-form-field>

                <div *ngIf="!currentPasswordEntity.isValid" class="d-flex flex-column valdations-list">
                    <h6 class="title label mb-2">Current Password Must:</h6>
                    <p *ngIf="!newPasswordEntity.isLengthValid" [ngClass]="{'valid': newPasswordEntity.isLengthValid }">Not be Empty</p>
                </div>

                <div *ngIf="!newPasswordEntity.isValid" class="d-flex flex-column valdations-list">
                    <h6 class="title label mb-2">New Password Must:</h6>
                    <p *ngIf="!newPasswordEntity.isLengthValid" [ngClass]="{'valid': newPasswordEntity.isLengthValid }">Have at least 8 Characters</p>
                    <p *ngIf="!newPasswordEntity.hasAlphabet" [ngClass]="{'valid': newPasswordEntity.hasAlphabet}">
                        Have at least 1 letter (a, b, c...)</p>
                    <p *ngIf="!newPasswordEntity.hasNumber" [ngClass]="{'valid': newPasswordEntity.hasNumber }">
                        Have at least 1 number (1, 2, 3...)</p>
                    <p *ngIf="!newPasswordEntity.hasEspecialChar" [ngClass]="{'valid': newPasswordEntity.hasEspecialChar}">
                        Have at least 1 especial character except % and +</p>
                    <p *ngIf="!newPasswordEntity.hasUpperLowerCase" [ngClass]="{'valid': newPasswordEntity.hasUpperLowerCase}">
                        Include both Upper case and Lower Case</p>
                </div>

                <button mat-button title="Change Password" type="submit" mat-flat-button class="button-default" color="primary" [disabled]="!isSetPasswordEnabled" (click)="changePassword()">Change Password
                </button>
            </form>
        </ng-container>

        <ng-container *ngIf="showPwdSuccessful">
            <div class="password-changed no-data-found">
                <i class="fa-solid fa-circle-check text-blue-light"></i>
                <h6>Password Changed Successfully</h6>
                <p>Please login again with your new password</p>
              </div>
        </ng-container>
    </div>
</div>
